export default __webpack_public_path__ + "static/media/emptyBetslip.edd93c22.png";